module.exports = __webpack_public_path__ + "img/vertical_4_6_3016.995a9f30.png";